<template>
  <div class="seomain">
    <ul class="tab-tilte">
      <li
        v-for="(title, index) in tabTitle"
        @click="
          changeActiveIndex(index);
          get_st_list(index);
        "
        :class="{ active: cur == index }"
        class="text-center"
        :key="index"
      >
        <span>{{ title }}</span>
      </li>
      <div class="cl"></div>
    </ul>
    <!-- 搜索  单行 -->
    <!-- <div class="keyword">
      <van-search
        v-model="order_code"
        shape="round"
        show-action
        background="#e0e0e0"
        placeholder="请输入订单号搜索"
        @search="onSearch"
        @cancel="onCancel"
      />
    </div> -->

    <!-- 搜索 多行 -->
    <div class="keyword">
      <van-form @submit="submitKeyword">
        <van-field v-model="order_code" label="单号" placeholder="请输入单号" />
        <van-field v-model="sku" label="SKU" placeholder="SKU" />
        <div :style="{ padding: '16px', backgroundColor: '#fff' }">
          <van-button round block type="info" native-type="submit">搜 索</van-button>
        </div>
      </van-form>
    </div>
    <div class="tab-content tab-content-list">
      <div v-show="cur == 0" class="st-list-box pan-0">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="没有权限,请联系管理员."
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="st-list" v-for="(v, k) in stlist0" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">采购编号</div>
            </div>
            <div class="st-list-main">
              <p v-if="v.scrapped_order_code">下架工单号：{{ v.scrapped_order_code }}</p>
              <p>采购类型：{{ v.style }}</p>
              <p>采购总金额：{{ v.amount }}</p>
              <p>操作人：{{ v.operator_name }}</p>
              <p>预计交期：{{ v.deliverytime }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>物流方：{{ v.shippingsupplier }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/receive/info/0/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
          </div></van-list
        >
      </div>
      <div v-show="cur == 1" class="st-list-box pan-0">
        <van-list
          v-model="loading"
          :finished="finished"
          :error.sync="error"
          error-text="没有权限,请联系管理员."
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="st-list" v-for="(v, k) in stlist1" :key="k" :index="k">
            <div class="st-list-top">
              <div class="t-tit">{{ v.code }}</div>
              <div class="t-status">调拨编号</div>
            </div>
            <div class="st-list-main">
              <p>调出仓库：{{ v.warehouse_out_name }}</p>
              <p>调入仓库：{{ v.warehouse_in_name }}</p>
              <p @click="getExInfo(v.id)">物流单号：{{ v.shipmentnumber }}</p>
              <p>物流方：{{ v.shippingsupplier }}</p>
              <p>收货地址：{{ v.destination_address }}</p>
              <p>实际到岗时间：{{ v.arrivaltime }}</p>
              <p>备注：{{ v.inwayremark || "无" }}</p>
            </div>
            <div class="st-list-bottom">
              <router-link :to="'/receive/info/1/' + v.id" class="st-opt-btn">查 看</router-link>
            </div>
          </div></van-list
        >
      </div>
    </div>

    <van-dialog class="exDialog" ref="exDialog" v-model="exShow" :title="exDialogTitle">
      <van-steps direction="vertical" :active="0" active-color="#fa6e09">
        <van-step v-for="(item, index) in exDataList" :key="index">
          <h3>{{ item.time }}</h3>
          <p>{{ item.step }}</p>
        </van-step>
      </van-steps>
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from "vant";
export default {
  components: {},
  props: {},
  data() {
    return {
      error: false,
      loading: false,
      finished: false,
      page: 1,
      tabTitle: ["采购签收", "调拨签收"],
      cur: 0,
      status: 0,
      id: "", // 提交确认时的id
      stlist0: [],
      stlist1: [],
      exShow: false,
      exDataList: [], // 物流信息
      exDialogTitle: "",
      allShow: false,
      code: "",
      order_code: "", // 关键字搜索
      sku: "",
    };
  },
  watch: {},
  computed: {
    dialogStlist() {
      return this.stlist0.filter((item) => item.id == this.dialogActiveId)[0];
    },
  },
  methods: {
    get_st_list() {
      this.stlist0 = [];
      this.stlist1 = [];
      this.page = 1;
      this.loading = true;
      this.finished = false;
      this.onLoad();
    },
    init() {
      this.get_st_list();
      // let activeIndex = window.sessionStorage.getItem("receive_activeIndex");
      // if (activeIndex) {
      //   this.cur = activeIndex;

      // }
    },
    changeActiveIndex(value) {
      this.cur = value;
      window.sessionStorage.setItem("receive_activeIndex", value);
    },
    doEdit(id, sku) {
      Dialog.confirm({
        title: "是否确认数据",
        message: `SKU:${sku}`,
      })
        .then(async () => {
          let result = await this.$post(this.$api.stSetQianshouEdit, {
            type: this.cur,
            id,
          });
          this.init();
          this.$toast.success("确认成功");
        })
        .catch(() => {
          // on cancel
        });
    },
    // 分页
    async onLoad() {
      try {
        let result = await this.$post(this.$api.stGetQianshouList, {
          order_code: this.order_code,
          type: this.cur,
          page: this.page,
          sku: this.sku,
        });
        if (result.data.length == 0) return (this.finished = true);

        // 进行操作
        this["stlist" + this.cur].push(...result.data);
        // 操作完成
        this.page += 1;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        if (error.code == 10403) {
          this.error = true;
        }
      }
    },
    // 获取物流信息
    async getExInfo(id) {
      let { shippingsupplier, shipmentnumber } = this["stlist" + this.cur].filter((item) => item.id == id)[0];
      this.exDialogTitle = shippingsupplier + ": " + shipmentnumber;

      if (this.cur == 1) {
        let result = await this.$post(this.$api.stGetDiaoboExInfo, { id });
        if (result.data.code == 1) {
          console.log(result.data.data);
          this.exDataList = result.data.data;
        } else {
          this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
        }
        this.exShow = true;
      } else if (this.cur == 0) {
        let result = await this.$post(this.$api.stGetCaigouExInfo, { id });
        if (result.data.code == 1) {
          console.log(result.data.data);
          this.exDataList = result.data.data;
        } else {
          this.exDataList = [{ step: "暂无轨迹信息,请确认订单号是否填写正确." }];
        }
        this.exShow = true;
      }
    },
    // 批量操作对应单号下的"确认签收"
    // onSignforById() {
    //   let code = this.code.trim();
    //   if (code == "") return this.$toast.fail("单号不能为空");
    //   this.$toast(code);
    // },
    onSearch(val) {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
    onCancel() {},
    // 关键字搜索
    submitKeyword() {
      this["stlist" + this.cur] = [];
      this.finished = false;
      this.page = 1;
      this.onLoad();
    },
  },
  created() {
    this.init();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "签收管理" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.keyword {
  position: fixed;
  width: 100%;
  top: 50px;
}
/* 2行input start */
.tab-content-list {
  padding-top: 220px;
}
/* 2行input  end */

.tab-tilte li {
  width: 50%;
}
</style>
